export default __webpack_public_path__ + "static/media/logo_alsum.2849e8a5.png";